export function getOneYearFromDate(date: Date): string {
  const yyyy = date.getFullYear() + 1;
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd} 00:00:00`;
}

export function getOneWeekFromDate(dateParam: Date): string {
  const date = new Date(dateParam);

  date.setDate(date.getDate() + 7);

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd} 00:00:00`;
}
